import { call, all, put, takeEvery } from 'redux-saga/effects';
import URLs from '../../../constants/urls';
import { GET_ASSESSMENT_CYCLES, SET_ASSESSMENT_CYCLES } from '../../actions/AssessmentCycles/actionTypes';
import { apiPython as api } from '../../../service/api';
import { DELETE_QUESTION_BANK, GET_QUESTION_BANK, GET_QUESTION_BANKS, SET_QUESTION_BANK } from '../../actions/QuestionBanks/actionTypes';
import {
  deleteQuestionBankFailureAction,
  deleteQuestionBankSuccessAction,
  getQuestionBankFailureAction,
  getQuestionBankSuccessAction,
  getQuestionBanksAction,
  getQuestionBanksFailureAction,
  getQuestionBanksSuccessAction,
  setQuestionBankFailureAction,
  setQuestionBankSuccessAction
} from '../../features/questionBanks/questionBanksSlice';
export function* getQuestionBanksSaga() {
  try {
    const response = yield api.get(URLs.GET_QUESTION_BANKS);
    yield put(getQuestionBanksSuccessAction(response.data.data));
  } catch (error) {
    yield put(getQuestionBanksFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Fetch failed'));
  }
}

export function* deleteQuestionBankSaga({ payload: id }) {
  const raw = id != null && id !== '' ? String(id) : '';
  if (!raw) {
    yield put(deleteQuestionBankFailureAction('Missing question id'));
    return;
  }
  try {
    const q = new URLSearchParams();
    q.set('id', raw);
    q.set('questionId', raw);
    const url = `${URLs.DELETE_QUESTION_BANKS}?${q.toString()}`;
    const response = yield api.post(url, {});
    const body = response.data;
    const ok = body?.status === 'Success' && Number(body?.data) === 1;
    yield put(deleteQuestionBankSuccessAction(body));
    if (ok) yield put(getQuestionBanksAction());
  } catch (error) {
    yield put(deleteQuestionBankFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not delete'));
  }
}

export function* setQuestionBankSaga({ payload }) {
  try {
    const parsed = typeof payload === 'string' ? JSON.parse(payload) : payload;
    const response = yield api.post(URLs.SET_QUESTION_BANK, parsed);
    const respBody = response.data;
    yield put(setQuestionBankSuccessAction(respBody));
    // Always reload list after a successful HTTP round-trip; envelope shape can vary by gateway.
    if (response.status >= 200 && response.status < 300) {
      yield put(getQuestionBanksAction());
    }
  } catch (error) {
    yield put(setQuestionBankFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
}

export function* getQuestionBankSaga({ payload: id }) {
  try {
    const response = yield api.get(`${URLs.GET_QUESTION_BANK}?id=${id}`);
    yield put(getQuestionBankSuccessAction(response.data.data));
  } catch (error) {
    yield put(getQuestionBankFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Fetch failed'));
  }
}

export function* watchQuestionBank() {
  yield takeEvery(GET_QUESTION_BANKS, getQuestionBanksSaga);
  yield takeEvery(DELETE_QUESTION_BANK, deleteQuestionBankSaga);
  yield takeEvery(SET_QUESTION_BANK, setQuestionBankSaga);
  yield takeEvery(GET_QUESTION_BANK, getQuestionBankSaga);
}

export default function* questionBankSaga() {
  yield all([watchQuestionBank()]);
}
